var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E0845",
    fillRule: "nonzero",
    d: "M13.451 4.964c2.439 0 3.398 1.735 3.398 1.735s-1.876.96-1.876 3.287c0 2.626 2.337 3.53 2.337 3.53s-1.634 4.6-3.84 4.6c-1.014 0-1.802-.684-2.87-.684-1.088 0-2.168.709-2.872.709-2.015 0-4.561-4.363-4.561-7.87 0-3.449 2.155-5.259 4.176-5.259 1.314 0 2.334.758 3.017.758.586 0 1.675-.806 3.091-.806zm.244-4.172s.236 1.413-.896 2.773c-1.21 1.453-2.584 1.215-2.584 1.215s-.258-1.142.756-2.478c1.14-1.503 2.724-1.51 2.724-1.51z"
  }))));
}
export default SvgApple;